import { createContext } from "react";

export const TimeLineContext = createContext(null);
